<template>
  <div id="app">
    <xy-head></xy-head>
    <router-view />
    <contact-information />
    <xy-foot></xy-foot>
  </div>
</template>

<script>
import xyHead from '@/components/header.vue'
import xyFoot from '@/components/footer.vue'
import contactInformation from '@/components/contactInformation.vue'
export default {
  name: 'App',
  components: {
    xyHead, xyFoot, contactInformation
  },
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #ffffff;
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue